import(/* webpackMode: "eager" */ "C:\\var\\coverz_ui\\src\\app\\(info)\\layout.tsx");
